import { useRouter } from "next/router";

const useIsTest = () => {
  const router = useRouter();
  return router.query.utm_source === "test";
};

export default useIsTest;
